import React, { useEffect, useState, useRef } from "react";
import shuffleNames from "@bd-utils/useRandomArrayList";

const TOTAL_SPIN_ITEMS = 45;

const NameRoulette = ({ onSelectedPlayer, members, isSpinning, duration }) => {
    const validMembers = Array.isArray(members)
        ? members.filter(
              (m) => m && typeof m === "string" && m.trim().length > 0,
          )
        : [];

    const [selectedWinner, setSelectedWinner] = useState("");
    const [unChosenWinner, setUnChosenWinner] = useState(validMembers);
    const [spinList, setSpinList] = useState([]);
    const previousWinnerRef = useRef("");

    useEffect(() => {
        setUnChosenWinner([...validMembers]);
    }, [members]);

    useEffect(() => {
        if (!isSpinning) {
            if (selectedWinner) {
                previousWinnerRef.current = selectedWinner;
            }
            return;
        }

        const currentValidMembers = Array.isArray(members)
            ? members.filter(
                  (m) => m && typeof m === "string" && m.trim().length > 0,
              )
            : [];

        if (currentValidMembers.length === 0) {
            setSelectedWinner("-");
            onSelectedPlayer("-");
            return;
        }

        // Use unChosenWinner pool if it contains valid members; otherwise reset from currentValidMembers
        let pool =
            unChosenWinner && unChosenWinner.length > 0
                ? unChosenWinner.filter((m) => currentValidMembers.includes(m))
                : [];

        if (pool.length === 0) {
            pool = [...currentValidMembers];
        }

        const randomList = shuffleNames(pool);
        const winner =
            randomList[randomList.length - 1] || currentValidMembers[0];

        // Build the 45-item spin list with winner strictly at the end:
        // Item 0: previous winner (to avoid visual jump when spin starts)
        // Items 1..TOTAL_SPIN_ITEMS - 2: randomized names from currentValidMembers
        // Item TOTAL_SPIN_ITEMS - 1: the chosen winner!
        const firstItem = previousWinnerRef.current || currentValidMembers[0];
        const generatedList = [firstItem];

        for (let i = 1; i < TOTAL_SPIN_ITEMS - 1; i++) {
            generatedList.push(
                currentValidMembers[i % currentValidMembers.length],
            );
        }
        const middleShuffled = shuffleNames(generatedList.slice(1));
        const fullSpinList = [firstItem, ...middleShuffled, winner];

        // Remove chosen winner from pool for the next spin
        const winnerIndex = pool.indexOf(winner);
        const remainingPool =
            winnerIndex !== -1
                ? [
                      ...pool.slice(0, winnerIndex),
                      ...pool.slice(winnerIndex + 1),
                  ]
                : pool.slice(0, -1);

        const nextPool =
            remainingPool.length > 0 ? remainingPool : [...currentValidMembers];

        setUnChosenWinner(nextPool);
        setSpinList(fullSpinList);
        setSelectedWinner(winner);
        onSelectedPlayer(winner);
    }, [isSpinning]);

    // Translate distance: exactly shift N-1 items up so that item N-1 (winner) lands precisely in the box
    const targetTranslatePercent =
        spinList.length > 1
            ? ((spinList.length - 1) / spinList.length) * 100
            : 0;

    const displayListName = (isSpinning) => (
        <div
            className={`v2-wheel-name-roulette__item-container ${
                isSpinning ? "is-spinning" : "is-not-spinning"
            }`}
            style={{
                transition: isSpinning
                    ? `transform ${duration}ms cubic-bezier(0.12, 0.8, 0.32, 1)`
                    : "none",
                transform: isSpinning
                    ? `translateY(-${targetTranslatePercent}%)`
                    : "translateY(0)",
            }}
        >
            {isSpinning && spinList.length > 0 ? (
                spinList.map((member, index) => {
                    return <p key={index}>{member}</p>;
                })
            ) : (
                <p style={{ animation: "none" }}>
                    {selectedWinner ||
                        (validMembers.length > 0 ? validMembers[0] : "-")}
                </p>
            )}
        </div>
    );

    return (
        <div className="v2-wheel-name-roulette">
            <div
                className={`v2-wheel-name-roulette--arrow ${
                    isSpinning ? "spinning" : ""
                }`}
            >
                <span />
            </div>
            <div className="v2-wheel-name-roulette__box">
                {displayListName(isSpinning)}
            </div>
            <div
                className={`v2-wheel-name-roulette--arrow ${
                    isSpinning ? "spinning" : ""
                }`}
            >
                <span />
            </div>
        </div>
    );
};

export default NameRoulette;
